import { collection, getDocs, doc, updateDoc, writeBatch } from 'firebase/firestore';
import { db, getCollectionPath } from '../lib/firebase';
import { Match, Team } from '../types';

export const migrateMatchesAddParticipantIds = async () => {
  try {
    console.log('Iniciando migración de partidos: agregando participantIds...');
    
    // 1. Fetch all teams to know who belongs to which team
    const teamsSnap = await getDocs(collection(db, getCollectionPath('teams')));
    const teamsData = new Map<string, string[]>();
    
    teamsSnap.docs.forEach(docSnap => {
      const team = docSnap.data() as Team;
      const players = [team.player1Id, team.player2Id, team.player3Id].filter(Boolean) as string[];
      teamsData.set(docSnap.id, players);
    });

    // 2. Fetch all matches
    const matchesSnap = await getDocs(collection(db, getCollectionPath('matches')));
    
    // 3. Process in batches (Firestore limit is 500 writes per batch)
    let batch = writeBatch(db);
    let count = 0;
    let totalUpdated = 0;

    for (const docSnap of matchesSnap.docs) {
      const match = docSnap.data() as Match;
      
      // If it already has participantIds, skip it
      if (match.participantIds && match.participantIds.length > 0) continue;

      const t1Players = teamsData.get(match.team1Id) || [];
      const t2Players = teamsData.get(match.team2Id) || [];
      
      const participantIds = [...t1Players, ...t2Players];
      
      if (participantIds.length > 0) {
        batch.update(docSnap.ref, { participantIds });
        count++;
        totalUpdated++;
      }

      // Commit batch every 400 operations to be safe
      if (count >= 400) {
        await batch.commit();
        console.log(`Commit de batch: ${totalUpdated} partidos actualizados hasta ahora.`);
        batch = writeBatch(db);
        count = 0;
      }
    }

    // Commit any remaining updates
    if (count > 0) {
      await batch.commit();
    }

    console.log(`Migración completada. Total de partidos actualizados: ${totalUpdated}`);
    return { success: true, updated: totalUpdated };

  } catch (error) {
    console.error('Error durante la migración:', error);
    return { success: false, error };
  }
};
